import {
  About,
  BaseSection,
} from 'modules/simulatorTrainings/common/components/ProductSheetFactory/components'
import { ProductSheetSection } from 'modules/simulatorTrainings/common/types/productSheet'
import { ProductSheetUtils } from 'modules/simulatorTrainings/common/utils'

type ProductSheetFactoryProps = {
  section: ProductSheetSection
}

const ProductSheetFactory: React.FC<ProductSheetFactoryProps> = ({ section }) => {
  const { type, content } = section
  if (!content) return null

  const { sectionArguments, isSectionHidden, sectionContent, sectionTitle } =
    ProductSheetUtils.parseSection(section)

  if (isSectionHidden) return null

  switch (type) {
    case 'Title':
    case 'CourseReference':
      return null

    case 'About':
      return <About description={sectionContent} sectionArguments={sectionArguments} />

    default:
      return (
        <BaseSection
          title={sectionTitle}
          content={sectionContent}
          sectionArguments={sectionArguments}
        />
      )
  }
}

export default ProductSheetFactory
